export default __webpack_public_path__ + "static/media/os3.8a683212.png";